import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-split-ticket-icon',
  templateUrl: './split-ticket-icon.component.html',
  styleUrl: './split-ticket-icon.component.scss',
  standalone: false
})
export class SplitTicketIconComponent {
  @Input() savings = '';
  @Input() currency = 'GBP';
}
